module.exports = __webpack_public_path__ + "img/front_page_models.82d2ec7b.svg";